import { Grid } from "@material-ui/core";
import { FileSaveIcon } from "App/Assets";
import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { today } from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

import ModalSimpan from "./ModalSimpan/ModalSimpan";

export const urlCreate = LIST_URL_WAREHOUSE.inputAdjustment.get;
export const urlProcess = LIST_URL_WAREHOUSE.inputAdjustment.process;

export const urlGetBarangByGudang =
  LIST_URL_WAREHOUSE.daftarInventoryControl.barangByGudang;
export const urlGetBarangByAdjusment =
  LIST_URL_WAREHOUSE.inputAdjustment.barangByAdjustment;

export const RESET_STATE_ADJUSMENT_STOCK = {
  id: "",
  date: today(true),
  gudang: "Pilih Gudang",
  gudang_id: null,

  status: false,
};

export const getAllBarangByGudang = async (
  formData,
  formFilter,
  pages,
  limit
) => {
  try {
    const api = await instance4.post(urlGetBarangByGudang, {
      halaman: pages,
      jumlah: limit,
      gudang_id: formData.gudang_id,
      barang_name: formFilter.barang_name,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getAllBarangByAdjusment = async (
  formData,
  formFilter,
  pages,
  limit
) => {
  try {
    const api = await instance4.post(urlGetBarangByAdjusment, {
      halaman: pages,
      jumlah: limit,
      adjustment_id: formData.id,
      barang_name: formFilter.barang_name,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const RenderSimpanButton = ({
  formData,
  setFormData,
  setNewAllData,
  setFormFilterBarangByGudang,
  formFilterBarangByGudang,
}) => {
  const [showModalSimpan, setShowModalSimpan] = useState(false);

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          formData={formData}
          setFormData={setFormData}
          setNewAllData={setNewAllData}
          setFormFilterBarangByGudang={setFormFilterBarangByGudang}
          formFilterBarangByGudang={formFilterBarangByGudang}
        />
      )}
      <div className='mt-2'>
        <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            outline={true}
            type={"button"}
            color='danger'
            name='RESET'
            onClick={() => setFormData(RESET_STATE_ADJUSMENT_STOCK)}
            size='md'
          />
          <MasterButton
            outline={false}
            type={"submit"}
            color='lightgreen'
            name='SIMPAN'
            size='md'
            onClick={() => setShowModalSimpan(!showModalSimpan)}
            withIcon={true}
            icon={<FileSaveIcon width='18px' height='18px' />}
          />
        </Grid>
      </div>
    </>
  );
};
